import axiosInstance from "../axiosInstance";
import Cookie from "js-cookie";

import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAIL,
	LOGOUT_REQUEST,
} from "../constants/session";

const login = (email, password) => async (dispatch) => {
	dispatch({ type: LOGIN_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/login", {
			email,
			password,
		});

		dispatch({
			type: LOGIN_SUCCESS,
			payload: data,
		});
		Cookie.set("adminInfo", data.data, { expires: 1 });
	} catch (error) {
		console.log("error ", error);
		const message = error.response.data.error;
		dispatch({ type: LOGIN_FAIL, payload: message });
	}
};

const logout = () => async (dispatch) => {
	dispatch({ type: LOGOUT_REQUEST });
};

export { login, logout };
